module.exports = __webpack_public_path__ + "img/screencapture-netflix-watch-81262748-2021-10-01-22_40_03.68d2a6ef.png";